import { Link, useParams } from 'react-router-dom'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { getPost, posts } from '../data/content'

const formatDate = (value) => new Date(`${value}T12:00:00`).toLocaleDateString('es-MX', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

const PostDetail = () => {
  const { slug } = useParams()
  const post = getPost(slug)

  if (!post) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-28 text-center">
        <p className="eyebrow">Blog</p>
        <h1 className="display mt-4 text-4xl">Ese artículo no está.</h1>
        <Link to="/blog" className="btn-primary mt-8">
          Volver a la bitácora
        </Link>
      </div>
    )
  }

  const related = posts.filter((item) => item.slug !== post.slug).slice(0, 2)

  return (
    <article className="bg-ivory">
      <header className="bg-fairway text-cream">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 md:py-24">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-semibold text-sun">
            <ArrowLeft className="h-4 w-4" />
            Bitácora
          </Link>
          <p className="eyebrow mt-8 text-sun">{post.category}</p>
          <h1 className="mt-4 font-serif text-4xl font-semibold leading-tight md:text-6xl">{post.title}</h1>
          <p className="mt-6 text-lg leading-relaxed text-cream/80">{post.excerpt}</p>
          <p className="mt-8 text-sm text-cream/60">
            {formatDate(post.date)} · {post.readTime} · Asociación Nacional de Golf Adaptado
          </p>
        </div>
      </header>

      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <div className="space-y-12">
          {post.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-serif text-3xl text-ink">{section.heading}</h2>
              <div className="mt-4 space-y-4 text-lg leading-relaxed text-mist">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16 border-t border-leaf/10 pt-10">
          <h2 className="font-serif text-2xl">Sigue leyendo</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2">
            {related.map((item) => (
              <Link key={item.slug} to={`/blog/${item.slug}`} className="rounded-3xl bg-white p-6 ring-1 ring-leaf/10">
                <p className="text-xs font-semibold uppercase tracking-wide text-leaf">{item.category}</p>
                <p className="mt-3 font-serif text-xl leading-snug">{item.title}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-leaf">
                  Leer
                  <ArrowRight className="h-4 w-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </article>
  )
}

export default PostDetail
